module.exports = __webpack_public_path__ + "static/steps-tape-2034e6d7d00825b01bf698e3bd2713ed.webp";